import styled from "styled-components";
import { theme } from "../../../../constants/StyledComponents";

export const StyledManagementFooter = styled.div`
  border-top: 1px solid ${theme.colors.purple_2};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  padding: 12px 20px;
  height: 48px;
  gap: 20px;
`;
